import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ConversationSummaryStatesEnum} from '../../../../../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {TeammateModel} from '../../../../../../../libs/shared/core/src/models/api/teammateModel';
import {ThreeDots} from '../../../../../../../libs/shared/ui/src/components/composer/threeDots';
import {Icon} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {getHasAISummarizeFeature} from '../../../../../../store/data/company/companySelectors';
import {ConversationHeaderAiSummarizeWrapper} from './conversationHeaderAiSummarizeWrapper';

/*
 * Props.
 */

interface ConversationHeaderAiSummarizeLoadingStateProps {
  conversationId: number;
  summaryState: ConversationSummaryStatesEnum;
  teammate: TeammateModel;
}

/*
 * Style.
 */

const StyledContentWrapperDiv = styled.div`
  height: 26px;
  display: flex;
  flex-flow: row;
  gap: 8px;
  align-items: center;
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade90};
`;

/*
 * Component.
 */

export const ConversationHeaderAiSummarizeLoadingState: FC<
  ConversationHeaderAiSummarizeLoadingStateProps
> = ({conversationId, summaryState, teammate}) => {
  const theme = useUserTheme();
  const hasFeature = useAppSelector(getHasAISummarizeFeature);

  const renderContent = () => (
    <StyledContentWrapperDiv>
      <Icon name="sparklesAiFilledSmall" color={theme.greys.shade80} />
      <Trans id="conversation-header-ai-summarizing">Summarizing</Trans>
      <ThreeDots size={VisualSizesEnum.SMALL} color={theme.palette.blue.shade40} />
    </StyledContentWrapperDiv>
  );

  if (!hasFeature) {
    return null;
  }

  return (
    <ConversationHeaderAiSummarizeWrapper isButtonDisabled isButtonHidden={false}>
      {renderContent()}
    </ConversationHeaderAiSummarizeWrapper>
  );
};
